import React from 'react';
import { GoStarFill } from "react-icons/go";
import { RxCross2 } from "react-icons/rx";
import { FaCalendarAlt, FaStethoscope, FaExclamationTriangle, FaClipboardList, FaHourglass, FaUserMd } from "react-icons/fa";
import './TimelineEvent.scss';

const TimelineEvent = ({ event, onClick, isFirst, isLast }) => {
  // Determine icon based on event type
  const getEventIcon = () => {
    switch (event.type) {
      case 'surgery':
        return <FaUserMd />;
      case 'clinic-visit':
        return <FaStethoscope />;
      case 'complication':
        return <FaExclamationTriangle />;
      case 'survey':
      case 'pending-survey':
        return <FaClipboardList />;
      default:
        return <FaCalendarAlt />;
    }
  };

  // Get status indicator
  const getStatusIndicator = () => {
    if (event.type === "pending-survey") {
      return event.active ? (
        <span className="status-indicator pending">
          <FaHourglass />
        </span>
      ) : (
        <span className="status-indicator inactive">
          <RxCross2 />
        </span>
      );
    }
    if (event.type === "surgery" && event.active) {
      return (
        <span className="status-indicator active">
          <GoStarFill />
        </span>
      );
    }
    return null;
  };

  return (
    <div
      className={`timeline-event ${event.type}-event ${isFirst ? 'first' : ''} ${isLast ? 'last' : ''}`}
      id={event.timelineId}
    >
      <div className="timeline-dot-container">
        <div className="timeline-dot">
          {getEventIcon()}
        </div>
      </div>

      <div
        className="timeline-event-card"
        onClick={onClick}
      >
        <div className="event-study-badge">
          <span className="study">{event.study}</span>
          <span className="side">({event.side})</span>
        </div>

        <div className="event-content">
          <div className="event-name">
            <span
              style={event.surgeryColor ? {
                boxShadow: `inset 0 -4px 0 0 ${event.surgeryColor}80`,
                paddingBottom: '-22px'
              } : {}}
            >
              {event.name}
            </span>
            {getStatusIndicator()}
          </div>
          <div className="event-date">
            <FaCalendarAlt />
            {event.date.format("DD/MM/YYYY")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineEvent;